import { useState, useCallback } from "react";

export function useEditorState({ startCollapsed = false } = {}) {
  // startCollapsed (arriving from the AI creator) shows the live preview full
  // width with the side panel closed, instead of the default open AI panel.
  const [webViewMode, setWebViewMode] = useState(startCollapsed);
  const [sidePanelView, setSidePanelView] = useState("ai"); // 'code' | 'ai'
  const [isFileExplorerVisible, setIsFileExplorerVisible] = useState(false);
  const [showCodeEditor, setShowCodeEditor] = useState(false);
  const [panelMode, setPanelMode] = useState("ai"); // 'files' | 'code' | 'ai'
  const [hasChanged, setHasChanged] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [panelPosition, setPanelPosition] = useState({ top: 0, right: 0 });
  const [isLink, setIsLink] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);
  const [isPickerActive, setIsPickerActive] = useState(false);

  const toggleWebViewMode = useCallback(() => {
    setWebViewMode((prev) => !prev);
  }, []);

  const showCodePanel = useCallback(() => {
    setSidePanelView("code");
  }, []);

  const showAIPanel = useCallback(() => {
    setSidePanelView("ai");
  }, []);

  const toggleFileExplorer = useCallback(() => {
    setIsFileExplorerVisible((prev) => !prev);
  }, []);

  const showElementPanel = useCallback((element, isLinkElement = false) => {
    const rect = element.getBoundingClientRect();
    setPanelPosition({ top: rect.top, right: rect.right });
    setShowPanel(true);
    setIsLink(isLinkElement);
    if (isLinkElement) {
      setSelectedLink(element);
    }
  }, []);

  const hidePanel = useCallback(() => {
    setShowPanel(false);
    setIsLink(false);
    setSelectedLink(null);
  }, []);

  const markChanged = useCallback(() => {
    setHasChanged(true);
  }, []);

  const clearChanged = useCallback(() => {
    setHasChanged(false);
  }, []);

  return {
    // View state
    webViewMode,
    setWebViewMode,
    toggleWebViewMode,
    sidePanelView,
    setSidePanelView,
    showCodePanel,
    showAIPanel,
    isFileExplorerVisible,
    setIsFileExplorerVisible,
    toggleFileExplorer,
    showCodeEditor,
    setShowCodeEditor,
    panelMode,
    setPanelMode,

    // Change tracking
    hasChanged,
    setHasChanged,
    markChanged,
    clearChanged,

    // Element panel
    showPanel,
    setShowPanel,
    panelPosition,
    isLink,
    selectedLink,
    showElementPanel,
    hidePanel,

    // Picker
    isPickerActive,
    setIsPickerActive,
  };
}
